export default (get, size) => {
  return Object.keys(get().compatibilitySegments).filter(
    (key) => get().compatibilitySegments[key].find((item) => item.size === size));
};
